import styled from 'styled-components';

export const StyledRootLoadingSpinner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(0 0 0 / 30%);
  z-index: 10;
`;
